var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgDocumentOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00692 10.5669C3.00692 10.1483 3.34627 9.80892 3.76488 9.80892H8.66934C9.08795 9.80892 9.4273 10.1483 9.4273 10.5669C9.4273 10.9855 9.08795 11.3248 8.66934 11.3248H3.76488C3.34627 11.3248 3.00692 10.9855 3.00692 10.5669Z",
    fill: "var(--secondary-5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76488 7.13376C3.34627 7.13376 3.00692 7.47311 3.00692 7.89172C3.00692 8.31033 3.34627 8.64968 3.76488 8.64968H6.8859C7.30451 8.64968 7.64386 8.31033 7.64386 7.89172C7.64386 7.47311 7.30451 7.13376 6.8859 7.13376H3.76488Z",
    fill: "var(--secondary-5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.65023 0C1.49289 0 0.554688 0.938206 0.554688 2.09554V11.9045C0.554688 13.0618 1.49289 14 2.65023 14H9.78399C10.9413 14 11.8795 13.0618 11.8795 11.9045V4.29182C11.8795 3.80735 11.6666 3.34737 11.2972 3.03393L8.1832 0.391784C7.88509 0.138846 7.50685 0 7.11589 0H2.65023ZM2.07061 2.09554C2.07061 1.77543 2.33011 1.51592 2.65023 1.51592H6.66297V3.43313C6.66297 4.41809 7.46144 5.21657 8.44641 5.21657H10.3636V11.9045C10.3636 12.2246 10.1041 12.4841 9.78399 12.4841H2.65023C2.33011 12.4841 2.07061 12.2246 2.07061 11.9045V2.09554Z",
    fill: "var(--secondary-5)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentOutlined);
export default __webpack_public_path__ + "static/media/documentOutlined.77e609f01297443a63128451685c44ba.svg";
export { ForwardRef as ReactComponent };